import { Link } from 'react-router-dom'
import LogoWhite from '../assets/icon-w.svg'

function Footer() {
  return (
    <div className="bg-black pt-24 pb-36 relative">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-12 gap-8">
        <div className="col-span-12 align-middle justify-between flex">
          <div>
            <img src={LogoWhite} alt="Logo" className="h-8" />
          </div>
          <div className="text-right text-white">
            <p>hello@clarkesthird.com</p>
            <p>+1 (646) 450-4277</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-5 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between">
          <p className="text-customGray text-sm">
            © 2025 ClarkesThird Inc.
          </p>
          <p className="text-customGray text-sm">
            <Link to='/terms'>Terms & Conditions</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Footer;